import { Pipe, PipeTransform } from '@angular/core';
import { Entry } from '../model/controllerNotes/entry';

@Pipe({ name: 'noteEntryString' })
export class NoteEntryStringPipe implements PipeTransform {
  transform(value: Entry[]): string {
    if (value.length != 0) {
      return value[0].note.substring(0, 240);
    } else {
      return 'No notes found';
    }
  }
}
